<template>
  <div class="row">
    <form class="user-token-form" @submit="handleSubmit">
      <label for="user-id">Fetch User Details</label>
      <input
        id="user-id"
        v-model="userEmail"
        class="userid-input mt-3"
        autofocus="true"
        type="text"
        placeholder="Enter email or user id"
      />
      <button
        class="p-3 shadow-md px-12 rounded-full mt-6 mb-8 border-none text-white font-bold bg-green"
      >
        Fetch Details
      </button>
    </form>
    <div>
      <div v-if="userCohorts.length" class="user-info-container">
        <h3 rows="1" cols="10">User Cohorts Info</h3>
        <div class="row mt-5">
          <div class="small-12 columns mb-5">
            <table>
              <thead>
                <tr>
                  <th>Cohort Name</th>
                  <th>Cohort Slug</th>
                  <th>Is Active</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(cohort, i) in userCohorts"
                  :key="i"
                  class="text-left"
                >
                  <td>{{ cohort.cohort_name }}</td>
                  <td>{{ cohort.cohort_slug }}</td>
                  <td>{{ cohort.is_active }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div
        v-if="userEmail && userID && token"
        class="user-info-container js-for-console-display-container"
      >
        <h3 rows="1" cols="10" class="mb-5">
          Generated JavaScript Code
        </h3>
        <pre
          style="
         overflow:auto;
         margin: auto;
         padding-left: 15px;
         border: dotted 1px black;
         text-align: left;"
        ><code>{{ generatedJsCodeForConsole }}</code>
     </pre>
        <button
          class="p-2 mb-5 mt-5 bg-grey shadow-md"
          @click="copyJSCodeToClipboard"
        >
          Copy this code
        </button>
      </div>
      <div v-if="preferences" class="user-info-container">
        <label rows="1" cols="10">Preferences</label>
        <textarea rows="5" cols="40" :value="preferences"></textarea>
      </div>
    </div>
  </div>
</template>

<script>
import siteConfig from "@/utils/siteConfig"

export default {
  data() {
    return {
      userEmail: undefined,
      userID: undefined,
      token: undefined,
      preferences: undefined,
      userCohorts: [],
    }
  },
  computed: {
    generatedJsCodeForConsole() {
      if (this.userEmail && this.userID && this.token) {
        return `
localStorage.userID = '${this.userID}'
localStorage.token = '${this.token}'
window.location.reload()
        `.trim()
      }
      return ""
    },
  },
  methods: {
    handleSubmit(e) {
      e.preventDefault()
      this.fetchToken()
      console.log("submitted")
    },
    fetchToken() {
      this.axios({
        method: "get",
        url: `${siteConfig.siteURL}admin/get_jwt/${this.userEmail}?query_cohorts=1`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      })
        .then(res => {
          this.userID = res.data.user_id || ""
          this.token = res.data.token
          this.preferences = JSON.stringify(res.data.preferences, null, 2)
          const { cohorts } = res.data.user_cohorts
          this.userCohorts = []
          Object.keys(cohorts).forEach(id => {
            this.userCohorts.push(cohorts[id])
          })
          this.$noty.success("Successfully fetched the token!", {
            layout: "topRight",
            theme: "relax",
          })
        })
        .catch(err => {
          this.$noty.error("Failed to fetch token!", {
            layout: "topRight",
            theme: "relax",
          })
          console.error(err)
        })
    },
    copyJSCodeToClipboard() {
      const dummy = document.createElement("textarea")
      document.body.appendChild(dummy)
      dummy.value = this.generatedJsCodeForConsole
      dummy.select()
      document.execCommand("copy")
      document.body.removeChild(dummy)
      this.$noty.success("Copied generated JS code to Clipboard!", {
        layout: "topRight",
        theme: "relax",
      })
    },
  },
}
</script>

<style scoped>
.user-token-form {
  max-width: 500px;
  margin: auto;
  margin-top: 80px;
  text-align: center;
}
.user-token-form > input {
  padding: 10px;
  border: 2px solid grey;
  border-radius: 5px;
}
.user-token-form > input:focus {
  border: 2px solid green;
}
.user-token-form > label {
  font-size: 18px;
  cursor: pointer;
}
.user-info-container {
  width: 600px;
  margin: auto;
  text-align: center;
}
.user-info-container > label {
  display: block;
  padding: 10px;
  font-size: 16px;
  text-align: center;
}
</style>
